module.exports = __webpack_public_path__ + "static/media/microsoft.8b541fc8.webp";